// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"533bc31d","498":"dd14e47b","703":"d80f54cc"}[chunkId] + ".chunk.js";
};